import { ICellRendererParams } from "ag-grid-community";
import dayjs from "dayjs";
import { formatDate } from "@/lib/Formatters/formatDate";
import { ExclamationTriangleIcon } from "@heroicons/react/16/solid";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";

export function FutureDateCell(props: ICellRendererParams<any>) {
  const cellValue = props.valueFormatted ? props.valueFormatted : props.value;

  if (!cellValue) return null;

  const date = dayjs(cellValue);
  const today = dayjs().startOf("day");
  const isPast = date.isBefore(today);
  const isToday = date.isSame(today, "day");

  // Check if this is available_to and if it's before available_from
  const isAvailableTo = props.colDef?.field === "available_to";
  const availableFrom = props.data?.available_from;
  const isBeforeAvailableFrom =
    isAvailableTo &&
    availableFrom &&
    dayjs(availableFrom).isValid() &&
    date.isBefore(dayjs(availableFrom));

  if (!date.isValid()) {
    return (
      <div className="flex h-full w-full items-center gap-2 bg-red-50 text-red-900">
        <span className="font-medium">Invalid date</span>
      </div>
    );
  }

  if (isBeforeAvailableFrom) {
    return (
      <div className="flex h-full w-full items-center gap-2 bg-red-50 text-red-900">
        <Tooltip>
          <TooltipTrigger asChild>
            <ExclamationTriangleIcon className="h-4 w-4 shrink-0 text-red-600" />
          </TooltipTrigger>
          <TooltipContent>
            Available to must be on or after available from
          </TooltipContent>
        </Tooltip>
        <span className="font-medium">{formatDate(date)}</span>
      </div>
    );
  }

  if (isPast) {
    return (
      <div className="flex h-full w-full items-center gap-2 bg-yellow-50 text-yellow-900">
        <Tooltip>
          <TooltipTrigger asChild>
            <ExclamationTriangleIcon className="h-4 w-4 shrink-0 text-yellow-600" />
          </TooltipTrigger>
          <TooltipContent>Date is in the past</TooltipContent>
        </Tooltip>
        <span className="font-medium">{formatDate(date)}</span>
      </div>
    );
  }

  if (isToday) {
    return (
      <div className="flex h-full w-full items-center gap-2 bg-orange-50 text-orange-900">
        <Tooltip>
          <TooltipTrigger asChild>
            <ExclamationTriangleIcon className="h-4 w-4 shrink-0 text-orange-600" />
          </TooltipTrigger>
          <TooltipContent>Pickup today</TooltipContent>
        </Tooltip>
        <span className="font-medium">{formatDate(date)}</span>
      </div>
    );
  }

  return <div className="font-medium">{formatDate(date)}</div>;
}
